export const uiRoutes = {
   home: () => '/warscholar/',
   book: () => '/warscholar/book',
   credits: () => '/warscholar/credits',
   play: () => '/warscholar/play',
   options: () => '/warscholar/options',
   shop: () => '/warscholar/shop'

};
